import React from "react";
import LabelledSelect from "components/LabelledSelect";
import { SelectOption } from "components/Select";
import { SearchInput } from "components/SearchInput";
import { JobsSortBy } from "pages/crawler/components/jobs/types";

const JOBS_SORT_OPTIONS: SelectOption<JobsSortBy>[] = [
  { value: "lastRun", name: "Last run" },
  { value: "status", name: "Status" },
  { value: "created", name: "Created" },
];

export interface JobsTableControlsProps {
  totalCount?: number;
  shownCount?: number;
  sortBy: JobsSortBy;
  onSortChange: (value: JobsSortBy) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

const CrawlerJobsTableControls: React.FC<JobsTableControlsProps> = ({
  totalCount,
  shownCount,
  sortBy,
  onSortChange,
  searchQuery,
  onSearchChange,
}) => {
  return (
    <div className="flex items-center justify-end sm:justify-between py-4 flex-wrap gap-4">
      <div className="text-sm text-gray-600">
        {typeof shownCount === 'number' && typeof totalCount === 'number'
          ? `Showing ${shownCount} of ${totalCount}`
          : `Total jobs: ${totalCount ?? shownCount ?? ''}`}
      </div>
      <div className="flex items-center gap-4 flex-wrap justify-end">
        <LabelledSelect
          label="Sort by"
          value={JOBS_SORT_OPTIONS.find((option) => option.value === sortBy) ?? JOBS_SORT_OPTIONS[0]}
          options={JOBS_SORT_OPTIONS}
          onChange={(option: SelectOption<JobsSortBy>) => onSortChange(option.value)}
          className="w-[216px]"
        />
        <div className="w-64">
          <SearchInput
            searchValue={searchQuery}
            onSearchChange={onSearchChange}
            placeholder="Search jobs"
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default CrawlerJobsTableControls;
